export const breadcrumb = {
  title: 'HLR',

  requests: {
    index: 'Запросы'
  }
};
